const accessDashboard = {

    DASHBOARD: {
        path: '/dashboard'
    },

    DASHBOARDSECOND: {
        path: '/'
    },

    PREMISE_COUNT: { name: 'Premise Count', path: '/premise-count' },
    RESIDENT_COUNT: { name: 'Resident Count', path: '/resident-count' },
    TICKET_COUNT: { name: 'Ticket Count', path: '/ticket-count' },
}

export default accessDashboard;